export const initObjectManager = () => new ymaps.ObjectManager({
	clusterize: false
});
